export var getStaticFilesEnv = function getStaticFilesEnv(env) {
  if (['oldstaging', 'staging'].includes(env)) {
    return 'production';
  }
  return env;
};